module.exports = __webpack_public_path__ + "img/business-solutions-secondary-hero-tablet@2x.981f9a43.webp";